'use strict';

var _ = require('lodash');
var StrategiesController = function StrategiesController($scope, $timeout, strategiesService, conditionsAndActionsService, dataRetrieverService, dataRetrieverConstants, strategyConstants, serializeStrategyService, dataService, panelStateManager, strategiesStateService, saveStrategyService, userSecureService, featureToggleService, statementBoxService, Strategy) {
  var marketPrivilege = userSecureService.hasAuthorization('market-analysis', 'write');
  var flightPrivilege = userSecureService.hasAuthorization('flight-analysis', 'write');
  $scope.panelConfig = {
    activeStrategyType: strategyConstants.PANEL_TYPE.OPTIMIZATION
  };
  $scope.$watch('panelConfig.activeStrategyType', function () {
    $scope.showDefaultView();
    setDataRetriever();
  });
  function initializePanelStateManager() {
    var panelNames = ['templatesPanel', 'readonlyPanel', 'strategyListing', 'customStrategyPanel', 'closureStrategyPanel', 'allocationAuthAvailStrategyPanel'];
    var initiallyVisiblePanelsNames = ['strategyListing'];
    $scope.panelsManager = panelStateManager.getInstance(panelNames, initiallyVisiblePanelsNames);
  }
  function setDataRetriever() {
    strategyDataRetrieve = dataRetrieverService.getDataRetriever(dataRetrieverConstants.STRATEGY_SCREEN, getGridId());
  }
  function secureMarketFlightPrivilege() {
    var levels = [];
    if (marketPrivilege && !flightPrivilege) {
      _.filter(conditionsAndActionsService.getLevels($scope.panelConfig.activeStrategyType), function (level) {
        if (level.domain === 'ServiceClassPOS' || level.domain === 'MarketDemandClassGroup') {
          return levels.push(level);
        }
      });
    } else if (!marketPrivilege && flightPrivilege) {
      _.filter(conditionsAndActionsService.getLevels($scope.panelConfig.activeStrategyType), function (level) {
        if (level.domain !== 'ServiceClassPOS' && level.domain !== 'MarketDemandClassGroup') {
          return levels.push(level);
        }
      });
    } else {
      levels = conditionsAndActionsService.getLevels($scope.panelConfig.activeStrategyType);
    }
    if (featureToggleService.isDisabled('SPOS')) {
      _.forEach(levels, function (level) {
        if (_.includes(level.label, 'POS')) {
          level.label = _.trimEnd(_.replace(level.label, 'POS', ''));
        }
      });
    }
    return levels;
  }
  initializePanelStateManager();
  var strategyDataRetrieve = dataRetrieverService.getDataRetriever(dataRetrieverConstants.STRATEGY_SCREEN, dataRetrieverConstants.STRATEGY_LISTING_MODE);
  strategiesService.retrieveTemplateUsage();
  $scope.showReadonlyStrategy = function (selectedRow) {
    strategyDataRetrieve.retrieveComponentData().then(findRawData.bind(null, selectedRow)).then($scope.showReadonlyView);
  };
  $scope.showReadonlyView = function (strategy) {
    var readOnly = strategiesService.copyStrategy(strategy);
    $scope.readonlyStrategy = serializeStrategyService.parseStrategy(readOnly);
    setPanelVisibility(strategyConstants.StrategyType.READONLY);
  };
  $scope.showDefaultView = function () {
    $scope.panelsManager.setInitialVisibilityState();
    $scope.panelsManager.collapseAll();
  };
  $scope.hideReadonlyView = function () {
    $scope.showDefaultView();
    $scope.$broadcast('grid:clearSelection');
  };
  $scope.clearPanelsManagerState = function () {
    $scope.panelsManager.setVisible('readonlyPanel', false);
    $scope.panelsManager.setHidden('readonlyPanel', false);
  };
  $scope.expandCollapseHandler = function () {
    $scope.panelsManager.togglePanelVisibility('strategyListing');
    var isReadOnlyPanelVisible = $scope.panelsManager.isVisible('strategyListing');
    if ($scope.panelsManager.isVisible('templatesPanel')) {
      $scope.panelsManager.setCollapsed('templatesPanel', isReadOnlyPanelVisible);
    } else if ($scope.panelsManager.isVisible('readonlyPanel')) {
      $scope.panelsManager.setCollapsed('readonlyPanel', isReadOnlyPanelVisible);
    }
  };
  function getGridId() {
    return $scope.panelConfig.activeStrategyType === strategyConstants.PANEL_TYPE.OPTIMIZATION ? dataRetrieverConstants.STRATEGY_LISTING_MODE : dataRetrieverConstants.ALERT_STRATEGY_LISTING_MODE;
  }
  $scope.showHideHandler = function () {
    $scope.panelsManager.togglePanelHidden('readonlyPanel');
    $timeout(function () {
      $scope.$broadcast('grid:refresh:' + getGridId());
    }, 10);
  };
  $scope.isViewScreensVisible = function () {
    return $scope.panelsManager.isVisible('strategyListing') || $scope.panelsManager.isVisible('templatesPanel') || $scope.panelsManager.isVisible('readonlyPanel');
  };
  $scope.levelOptions = secureMarketFlightPrivilege();
  $scope.strategyTemplates = strategiesService.getStrategyTemplates();
  $scope.readonlyStrategy = {};
  $scope.editingStrategy = {};
  function updateCategories(levelDomain, flowType) {
    var activeStrategyType = $scope.panelConfig.activeStrategyType;
    var condition = conditionsAndActionsService.getConditionByDomain(levelDomain, activeStrategyType, flowType);
    var action = conditionsAndActionsService.getActionByDomain(levelDomain, activeStrategyType);
    $scope.conditionCategories = condition.categories;
    $scope.actionCategories = action.categories;
  }
  $scope.$on('strategy-custom:selectedLevelChanged', function (event, newLevelDomain, flowType) {
    if (newLevelDomain) {
      updateCategories(newLevelDomain, flowType);
    }
  });
  $scope.$on('strategy-custom:flowTypeChanged', function (event, levelDomain, flowType) {
    updateCategories(levelDomain, flowType);
  });
  $scope.$on('strategy:createStrategy', function (event, strategyType) {
    $scope.editingStrategy = {
      basis: strategyType,
      "public": true,
      type: $scope.panelConfig.activeStrategyType
    };
    setPanelVisibility(strategyType);
  });
  $scope.$on('strategy:editStrategy', function (event, strategyType, strategy) {
    strategy = serializeStrategyService.parseStrategy(strategy);
    var type = strategyType || strategyConstants.StrategyType.CUSTOM;
    strategy.old = strategiesService.copyStrategy(strategy);
    $scope.editingStrategy = new Strategy(strategy);
    setPanelVisibility(type);
  });
  $scope.$on('strategy:showReadonly', function (event, strategy) {
    $scope.showReadonlyStrategy(strategy);
  });
  $scope.$on('strategy:hideReadonly', function () {
    $scope.panelsManager.setVisible('readonlyPanel', false);
  });
  function setPanelVisibility(strategyType) {
    var type = strategyConstants.StrategyType;
    $scope.panelsManager.setVisible('strategyListing', strategyType === type.TEMPLATE || strategyType === type.READONLY);
    $scope.panelsManager.setVisible('templatesPanel', strategyType === type.TEMPLATE);
    $scope.panelsManager.setVisible('customStrategyPanel', strategyType === type.CUSTOM);
    $scope.panelsManager.setVisible('closureStrategyPanel', strategyType === type.CLASS_CLOSURE);
    $scope.panelsManager.setVisible('allocationAuthAvailStrategyPanel', strategyType === type.ALLOCATION_AUTH_AVAIL);
    $scope.panelsManager.setVisible('readonlyPanel', strategyType === type.READONLY);
  }
  function findRawData(gridRow, rawDataSet) {
    var strategy = _.cloneDeep(_.find(rawDataSet, {
      name: gridRow.name,
      technicalId: gridRow.technicalId
    }));
    saveStrategyService.strategyRestrictedToBoolean(strategy);
    return strategy;
  }
  $scope.$on('search-criteria:searchChangeEvent', function () {
    dataService.clearCache();
    $scope.showDefaultView();
  });
  $scope.$on('grid:beforeUpdateBoundData', function (event, data) {
    strategiesService.setStrategiesData(data);
    $scope.$broadcast('rules-panel:strategy-data-changed');
  });
  $scope.$on('strategy:dataAndSelectionChanged', function (e, data) {
    strategiesService.retrieveTemplateUsage();
    $scope.$broadcast('grid:dataAndSelectionChangedGrid:strategy-listing', [data]);
  });
  $scope.toggleReadOnlyPanelVisibilityState = function () {
    var selectedRow = strategiesStateService.getSelectedRow();
    if (selectedRow !== null) {
      $scope.showReadonlyStrategy(selectedRow);
    } else if ($scope.panelsManager.isVisible('readonlyPanel')) {
      $scope.clearPanelsManagerState();
    }
  };
  $scope.$on('strategies:toggleReadOnlyPanelVisibility', $scope.toggleReadOnlyPanelVisibilityState);
  $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId) {
    strategiesStateService.setSelectedRows(selectedRows);
    $scope.toggleReadOnlyPanelVisibilityState();
    $timeout(function () {
      $scope.$broadcast('grid:refresh:' + gridId);
    }, 10);
  });
  $scope.isStatementEmpty = function () {
    return statementBoxService.isStatementEmpty(null, $scope.editingStrategy);
  };
  $scope.$watch('panelConfig.activeStrategyType', function () {
    $scope.levelOptions = secureMarketFlightPrivilege();
  });
};
StrategiesController.$inject = ['$scope', '$timeout', 'StrategiesService', 'ConditionsAndActionsService', 'DataRetrieverService', 'DataRetrieverConstantsService', 'StrategyConstants', 'SerializeStrategyService', 'DataService', 'PanelStateManager', 'StrategiesStateService', 'SaveStrategyService', 'UserSecureService', 'FeatureToggleService', 'StatementBoxService', 'StrategyFactory'];
module.exports = StrategiesController;